import { render, staticRenderFns } from "./itemBox.vue?vue&type=template&id=bea18b9c&scoped=true&"
import script from "./itemBox.vue?vue&type=script&lang=js&"
export * from "./itemBox.vue?vue&type=script&lang=js&"
import style0 from "./itemBox.vue?vue&type=style&index=0&id=bea18b9c&scoped=true&lang=scss&"
import style1 from "./itemBox.vue?vue&type=style&index=1&id=bea18b9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea18b9c",
  null
  
)

export default component.exports